import zelleQR from "../assets/payments/zelle.png";
import venmoQR from "../assets/payments/venmo.png";

export type PaymentMethod = "zelle" | "venmo";

export const PAYMENT_METHODS = {
  zelle: {
    name: "Zelle",
    title: "Scan to pay with Zelle",
    detail: "connie@conniescakerie.com",
    src: zelleQR,
    alt: "Zelle QR code",
  },
  venmo: {
    name: "Venmo",
    title: "Scan to pay with Venmo",
    detail: "@conniescakerie",
    src: venmoQR,
    alt: "Venmo QR code",
  },
} as const;

export const PAYMENT_METHOD_IDS: PaymentMethod[] = ["zelle", "venmo"];
